import axios from 'axios';

// GET /admin/token-balances -> [{ sponsorId, name, email, eng:{...}, tech:{...} }]
export async function getTokenBalances() {
  try {
    const res = await axios.get('/admin/token-balances');
    return res.data.sponsors || [];
  } catch (error) {
    console.error(error);
    return [];
  }
}
